module.exports = __webpack_public_path__ + "static/media/BG_52.09a8ae4a.png";